import { API_BASE } from '../env';

function getAuth(): string {
  const raw = window.Telegram?.WebApp?.initData;
  if (raw) return `tma ${raw}`;
  // Dev fallback: `localStorage.setItem('dev_initdata', <output of make-initdata.mjs>)`
  const dev = typeof localStorage !== 'undefined' ? localStorage.getItem('dev_initdata') : null;
  if (dev) return `tma ${dev}`;
  return '';
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function apiFetch<T>(
  path: string,
  init?: RequestInit & { params?: Record<string, string | number | boolean | undefined> },
): Promise<T> {
  let url = `${API_BASE}/api${path}`;
  if (init?.params) {
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(init.params)) {
      if (v !== undefined) qs.set(k, String(v));
    }
    const s = qs.toString();
    if (s) url += `?${s}`;
  }

  const res = await fetch(url, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getAuth(),
      ...(init?.headers ?? {}),
    },
  });

  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: { message?: string } };
    throw new ApiError(res.status, body.error?.message ?? res.statusText);
  }

  const body = (await res.json()) as { ok: boolean; data: T };
  return body.data;
}
